import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getUrlBuilders } from '@bingads-webui-clientcenter/url-builder-base';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';
import { StepContainer } from '../step-container/step-container';
import { FinishView } from './finish-view';

const FinishStepUnwrapped = (props) => {
  const { showPmaxAutoSwitchMessage } = props;
  const i18n = useContext(I18nContext);
  const wizardContext = useContext(GoalCreationWizardContext);
  const selectedGoalType = wizardContext.goalContext.Type;
  const goalCreated = !wizardContext.startFromEdit;
  const hasConversionCoupon = wizardContext.hasConversionCouponFunc && wizardContext.hasConversionCouponFunc();

  const isEnhancedConversionsEnabled = wizardContext.goalContext.IsEnhancedConversionsEnabled;
  const EnhancedConversions = wizardContext.permissions && wizardContext.permissions.dynamic
      && wizardContext.permissions.dynamic.EnhancedConversions && isEnhancedConversionsEnabled;

  useEffect(() => {
    if (goalCreated && hasConversionCoupon && wizardContext.goalContext.Tag) {
      const alertHelper = new AlertHelper({ i18n });
      const { BillingUrlBuilder } = getUrlBuilders({
        ccBaseUrl: wizardContext.serverContext.Urls.ClientCenterBaseUrl,
        aidFetcher: () => wizardContext.serverContext.CurrentAccount.Id,
        cidFetcher: () => wizardContext.serverContext.CurrentCustomer.Id,
        uidFetcher: () => wizardContext.serverContext.CurrentUser.Id,
      });

      const couponAdoptedCallback = wizardContext.onCouponAdoptedFunc && wizardContext.onCouponAdoptedFunc();
      const couponWorkDone = couponAdoptedCallback ? couponAdoptedCallback() : Promise.resolve();
      couponWorkDone.then(() => {
        const link = new BillingUrlBuilder({ isShortUrl: false }).action('coupondetails').url;
        const baseMessage = `<b>${i18n.getString(_TL_('Almost there!'))}</b>  ${i18n.getString(_TL_('Once you have met the spend requirements and your UET tag and goal status remain active, you\'ll receive the credit. We\'ll notify you when the credit has been added to your account.'))} <a href='${link}'>${i18n.getString(_TL_('View promotional offers'))}</a>`;
        alertHelper.showSuccess(baseMessage);
      });
    }
  }, [goalCreated, hasConversionCoupon, i18n, wizardContext, wizardContext.goalContext.Tag, wizardContext.serverContext.CurrentAccount.Id, wizardContext.serverContext.CurrentCustomer.Id, wizardContext.serverContext.CurrentUser.Id, wizardContext.serverContext.Urls.ClientCenterBaseUrl]);


  const footerConfig = {
    buttons: [
      {
        type: 'Primary',
        onClick: () => wizardContext.exitWizard({ data: { goalModel: wizardContext.goalContext, goalCreated } }, true),
        isEnabled: true,
        text: i18n.getString(_TL_('Done')),
      },
    ],
  };

  return (
    <React.Fragment>
      <StepContainer
        title={i18n.getString(_TL_('All done!'))}
        step="end-flow"
        footerConfig={footerConfig}
      >
        <FinishView
          i18n={i18n}
          serverContext={wizardContext.serverContext}
          selectedGoalType={selectedGoalType}
          gtmContext={wizardContext.GTMContext}
          EnhancedConversions={EnhancedConversions}
          showPmaxAutoSwitchMessage={showPmaxAutoSwitchMessage}
        />
      </StepContainer>
    </React.Fragment>
  );
};

FinishStepUnwrapped.propTypes = {
  showPmaxAutoSwitchMessage: PropTypes.bool,
};

FinishStepUnwrapped.defaultProps = {
  showPmaxAutoSwitchMessage: false,
};

export const FinishStep = withPerfMarker(FinishStepUnwrapped);
